/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addaneweventforyourbusiness6Inputs */

const en_addaneweventforyourbusiness6 = /** @type {(inputs: Addaneweventforyourbusiness6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a new event for your business.`)
};

const de_addaneweventforyourbusiness6 = /** @type {(inputs: Addaneweventforyourbusiness6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füg ein neues Event für dein Unternehmen hinzu.`)
};

/**
* | output |
* | --- |
* | "Add a new event for your business." |
*
* @param {Addaneweventforyourbusiness6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const addaneweventforyourbusiness6 = /** @type {((inputs?: Addaneweventforyourbusiness6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addaneweventforyourbusiness6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addaneweventforyourbusiness6(inputs)
	return de_addaneweventforyourbusiness6(inputs)
});
export { addaneweventforyourbusiness6 as "addANewEventForYourBusiness" }